import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../Store/RootReducer";
import { Statements } from "./Statements";

interface PropsFromState {
  activeTradingAccountKey: string;
}

function ActiveTradingAccountStatementsCmp(props: PropsFromState) {
  return (
    <Statements tradingAccountKey={props.activeTradingAccountKey} />
  );
}

const mapStateToProps = (state: AppState): PropsFromState => {
  return {
    activeTradingAccountKey: state.activeTradingAccount.account!.Key
  };
};

export const ActiveTradingAccountStatements = connect(mapStateToProps)(ActiveTradingAccountStatementsCmp);
